import React from "react";
import TrfSimulatorContainer from "../../containers/TrfSimulatorContainer/TrfSimulatorContainer";

function TrfSimulatorRoute(){
  return(
      <TrfSimulatorContainer/>
  )
}

export default TrfSimulatorRoute;
